import { ContactSlugEnum } from '@systemeio/ui'
import { InitFieldsInterface } from 'modules/stores/store/components/contact-fields'

export const digitalProductInitFields: InitFieldsInterface[] = [
  { slug: ContactSlugEnum.Email, mandatory: true, required: true },
  { slug: ContactSlugEnum.FirstName, mandatory: true, required: true },
  { slug: ContactSlugEnum.Country, mandatory: false, required: true },
]
